module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "companies h-100 d-flex align-items-center"
  }, [(this.account.accessType && this.account.accessType == 1) ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "w-100",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "pointer d-flex align-items-center"
  }, [_c('strong', {
    staticClass: "supplierName"
  }, [_vm._v(_vm._s(_vm.brand))]), _vm._v(" "), (_vm.accessPermissionFilter(['admin'])) ? _c('span', {
    class: ['ml-auto', 'dark', 'ico-arrow-' + _vm.icon]
  }) : _vm._e()]), _vm._v(" "), (_vm.isVisible && _vm.accessPermissionFilter(['admin'])) ? _c('div', {
    staticClass: "settings fs-small lighter bg-lighter shadowed"
  }, [_c('div', {
    staticClass: "edit bg-lightest py-4 dark d-flex align-items-center"
  }, [_c('router-link', {
    staticClass: "dark",
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('strong', [_vm._v("Company settings")]), _vm._v(" "), _c('u', {
    staticClass: "ico-settings larger"
  })])], 1)]) : _vm._e()]) : _c('div', [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('strong', [_vm._v(_vm._s(_vm.brand))])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6d81db30", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d81db30"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Companies.vue
// module id = 1381
// module chunks = 0